<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form>
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input
          placeholder="Search report"
          class="w-full border p-2 rounded-md outline-none"
          matInput
          (input)="applyFilter($event)"
        />
      </div>
      <mat-form-field appearance="outline" class="w-60">
        <mat-label>Project</mat-label>
        <mat-select [(ngModel)]="projectId" name="pid" (selectionChange)="onProject()">
          <mat-option [value]="null">All</mat-option>
          <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.project_name || p.project_identifier || p.id }}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="w-60">
        <app-primary-button routerLink="/home/add-progress-report" class="flex w-40">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>Add Progress Report</span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>

  <div class="bg-white rounded-2xl shadow-md p-4">
    <h3 class="text-lg font-semibold mb-3">Record chainage DPR</h3>
    <form class="grid grid-cols-1 md:grid-cols-5 gap-3 items-end mb-4" (ngSubmit)="submit()">
      <mat-form-field appearance="outline">
        <mat-label>Location</mat-label>
        <mat-select [(ngModel)]="form.work_location_id" name="wl">
          <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Pavement layer</mat-label>
        <mat-select [(ngModel)]="form.pavement_work_item_id" name="wi">
          <mat-option *ngFor="let w of workItems" [value]="w.id">{{ w.layer_label }} &#64; {{ w.location_name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Qty</mat-label>
        <input matInput type="number" [(ngModel)]="form.qty" name="qty" required />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Remarks</mat-label>
        <input matInput [(ngModel)]="form.remarks" name="rm" />
      </mat-form-field>
      <button mat-raised-button color="primary" type="submit">Save DPR</button>
    </form>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="reportDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Report Date</th>
        <td mat-cell *matCellDef="let report">{{ report.reportDate | date }}</td>
      </ng-container>
      <ng-container matColumnDef="workDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Work Description</th>
        <td mat-cell *matCellDef="let report">{{ report.workDescription }}</td>
      </ng-container>
      <ng-container matColumnDef="progressPercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Qty</th>
        <td mat-cell *matCellDef="let report">{{ report.progressPercentage }}</td>
      </ng-container>
      <ng-container matColumnDef="qualityPassed">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Quality</th>
        <td mat-cell *matCellDef="let report">{{ report.qualityPassed ? 'Yes' : 'No' }}</td>
      </ng-container>
      <ng-container matColumnDef="inspectionDone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Layer linked</th>
        <td mat-cell *matCellDef="let report">{{ report.inspectionDone ? 'Yes' : 'No' }}</td>
      </ng-container>
      <ng-container matColumnDef="photo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>UOM</th>
        <td mat-cell *matCellDef="let report">{{ report.photo || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let report">
          <button mat-button color="primary" [routerLink]="['/home/add-progress-report']"><mat-icon>edit</mat-icon></button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
  </div>

  <div class="bg-white rounded-2xl shadow-md p-4">
    <h3 class="text-lg font-semibold mb-3">Geotagged photos</h3>
    <form class="grid grid-cols-1 md:grid-cols-5 gap-3 items-end mb-4" (ngSubmit)="addMedia()">
      <mat-form-field appearance="outline">
        <mat-label>Location</mat-label>
        <mat-select [(ngModel)]="mediaForm.work_location_id" name="mwl">
          <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.id }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Caption</mat-label>
        <input matInput [(ngModel)]="mediaForm.caption" name="cap" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Latitude</mat-label>
        <input matInput type="number" [(ngModel)]="mediaForm.latitude" name="mlat" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Longitude</mat-label>
        <input matInput type="number" [(ngModel)]="mediaForm.longitude" name="mlng" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>File URL / S3 key</mat-label>
        <input matInput [(ngModel)]="mediaForm.file_url" name="murl" />
      </mat-form-field>
      <button mat-raised-button color="primary" type="submit">Save media</button>
    </form>
    <table mat-table [dataSource]="media">
      <ng-container matColumnDef="cap">
        <th mat-header-cell *matHeaderCellDef>Caption</th>
        <td mat-cell *matCellDef="let row">{{ row.caption || row.file_url || row.s3_key }}</td>
      </ng-container>
      <ng-container matColumnDef="geo">
        <th mat-header-cell *matHeaderCellDef>GPS</th>
        <td mat-cell *matCellDef="let row">{{ row.geometry?.coordinates?.join(', ') || '—' }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['cap','geo']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['cap','geo']"></tr>
    </table>
    <p *ngIf="!media.length" class="text-center text-slate-400 py-4">No geotagged media yet.</p>
  </div>
</div>
